import { render, staticRenderFns } from "./menuDetail.vue?vue&type=template&id=911f18c4&scoped=true&"
import script from "./menuDetail.vue?vue&type=script&lang=js&"
export * from "./menuDetail.vue?vue&type=script&lang=js&"
import style0 from "./menuDetail.vue?vue&type=style&index=0&id=911f18c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911f18c4",
  null
  
)

export default component.exports